module.exports = __webpack_public_path__ + "img/PG1_1-3-259x195.f81032dd.png";